import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { ThemesHttpRepository } from "../repository";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/constants/routes";

const themesRepository = new ThemesHttpRepository();

export function useFetchTheme(id: string | undefined) {
  const navigate = useNavigate();
  const query = useQuery({
    queryKey: ["theme", id],
    queryFn: () => themesRepository.fetchOne(id ?? ""),
    enabled: !!id,
  });

  useEffect(() => {
    if (query.error) {
      navigate(ROUTES.THEMES);
    }
  }, [query.error, navigate]);

  return {
    theme: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
  };
}
